import { Pipe, PipeTransform } from '@angular/core';

/**
 * This a temp pipe which facilitates bridging the gap of binding inputs to native HTML attributes like `required`
 * which represent boolean values also as strings.
 * This won't be necessary once we migrate to Angular v16+, as we'll be able to use `@Input({ transform: booleanTransform })`
 *
 * @export
 * @class BooleanTransformPipe
 * @implements {PipeTransform}
 */
@Pipe({
    standalone: true,
    name: 'booleanTransform',
    pure: true
})
export class BooleanTransformPipe implements PipeTransform {
    public transform(value: string | boolean): boolean {
        return [true, 'true', ''].includes(value);
    }
}
